<template>
    <div class="create-asset__file-wrap">
        <div class="create-asset__left">
            <!--TODO: style a bit better error messages-->
            <!--Error messages-->
            <div v-if="errorMessages.length > 0" class="file__error">
                {{ errorMessages.join(',') }}
            </div>
            <!-- File component after loading-->
            <FileItem
                v-if="file"
                :file-item="file"
                :name="file.name"
                size="lg"
                class="create-asset__file"
                @removed="onRemoved"
            />
            <div
                v-if="!file"
                class="no-thumb"
            >
                <img :src="thumbnailSource"
                    class="icon-img"
                    alt="file-img"
                />
                <div class="no-thumb-text">
                    Add a thumbnail image.
                </div>
            </div>
        </div>
        <div v-if="version === 1" class="create-asset__right">
            <file-upload
                v-show="!file"
                ref="fileUpload"
                :max-files="1"
                :max-file-size="maxFileSize"
                :file-type="fileType"
                :url="url"
                :element-name="elementName"
                class="create-asset__file-wrapper--standalone"
                @upload-complete="onUploadComplete"
                @upload-progress="onUploadProgress"
                @upload-started="onUploadStarted"
            ></file-upload>
        </div>
    </div>
</template>

<script>
import FileItem from './FileItem.vue';
// import FileItemLoading from './FileItemLoading.vue';
import FileUpload from './FileUpload.vue';

export default {
    components: {
        FileItem,
        // FileItemLoading,
        FileUpload,
    },
    watch: {
        defaultValue(newVal, oldVal) {
            this.thumbnailSource = this.myImageSource();
        },
       fileItem(newVal, oldVal) {
            // if (this.newVal) {
                let val = {...newVal};
                if (Object.keys(val).length === 0) {
                    this.file = null
                } else {
                    this.file = val;
                }

            // }
       }
    },
    props: {
        errorMessages: {
            type: Array,
            default: () => [],
        },
        
        fileItem: {
            type: Object,
            default: () => null,
        },
        fileItemLoading: {
            type: Array,
            default: () => [],
        },
        defaultValue: {
            type: String,
            default: '',
        },
         // uploadInProgress: {
        //     type: Boolean,
        // },
        maxFiles: {
            type: Number,
            default: 1,
        },
        version: {
            type: Number,
            default: 1,
        },
        maxFileSize: {
            type: Number,
            default: 30,
        },
        fileType: {
            type: String,
            default: '',
        },
        elementName: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            thumbnailSource: '',
            tmpFileItem: null,
            file: null
        }
    },
    methods: {
        // TODO: now we're just populating up events, maybe we should smth with inheritAttrs
        onRemoved() {
            this.fileItem = null;
            this.$refs.fileUpload.resetInput();
            this.$emit('removed');
        },
         myImageSource(){
            let url;
            if (this.file && this.file.data && this.file.data.formData) {
                const file = this.file.data.formData.get('file');
                url = URL.createObjectURL(file);
                return url
            }
            if (this.defaultValue) {
                return this.defaultValue;
            }
            return require('Images/asset_thumb_placeholder.jpg');
        },
        onUploadProgress(files) {
            this.$emit('upload-progress', files);
        },
        onUploadComplete(files) {
            const file = files[0];
            this.$emit('upload-complete', file);
        },
        onUploadStarted(files) {
            this.$emit('upload-started', files);
        },
    },
};
</script>
<style lang="scss" scoped>
.create-asset__left {
    align-self: center;
}

.no-thumb {
    display: flex;
    align-items: center;
    .icon-img {
        margin-right: 10px;
        height: 60px;
        width: 60px;

        @media (max-width: $xs-down) {
            margin-bottom: 10px;
            margin-right: 0;
        }
    }
    .no-thumb-text {
        text-align: center;
    }
    @media (max-width: $xs-down) {
        flex-direction: column;
    }
}
</style>
